import { login } from "./login";
import { logout } from "./logout";
import { password } from "./password";
import { signup } from "./signup";
import { token } from "./token";

export const auth = {
  login,
  logout,
  password,
  signup,
  token,
};
